export const fillById = (id, arr = []) => {
  const ix = arr.findIndex((it) => it.id == id);
  if (ix != -1) {
    return arr[ix];
  }

  return { id };
};
